export enum LogsType {
  TRACE = 0,
  INFO,
  LOG,
  WARN,
  ERROR,
  FATAL
}
